// Busca de imóveis v2: modal de filtros, campo de bairros, galeria dos cards,
// alternância grade/lista, ordenação e "Carregar mais".

const CHAVE_VISAO = 'ni_visao_imoveis';

function lerStorage(chave, padrao) {
    try {
        const valor = window.localStorage.getItem(chave);
        return valor === null ? padrao : JSON.parse(valor);
    } catch (e) {
        return padrao;
    }
}

function gravarStorage(chave, valor) {
    try {
        window.localStorage.setItem(chave, JSON.stringify(valor));
    } catch (e) {
        // Navegação privada ou storage bloqueado: segue sem persistir.
    }
}

function normalizar(texto) {
    return texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

function formatarNumero(valor) {
    const digitos = String(valor).replace(/\D/g, '');
    return digitos ? Number(digitos).toLocaleString('pt-BR') : '';
}

// Modal de filtros ------------------------------------------------------------------

function iniciarModal() {
    const modal = document.getElementById('filtrosImoveis');
    if (!modal) {
        return;
    }
    const painel = modal.querySelector('.filtros-modal__painel');
    let origemFoco = null;

    function abrir(e) {
        if (e) {
            e.preventDefault();
            origemFoco = e.currentTarget;
        }
        modal.classList.add('is-aberto');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('filtros-aberto');
        window.setTimeout(() => painel.focus({ preventScroll: true }), 50);
    }

    function fechar() {
        modal.classList.remove('is-aberto');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('filtros-aberto');
        if (origemFoco) {
            origemFoco.focus();
        }
    }

    document.querySelectorAll('.js-abrir-filtros').forEach((botao) => botao.addEventListener('click', abrir));
    modal.querySelectorAll('.js-filtros-fechar').forEach((botao) => botao.addEventListener('click', fechar));
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-aberto')) {
            fechar();
        }
    });

    if (window.location.hash === '#filtros') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        abrir();
    }

    iniciarArrastarParaFechar(painel, modal.querySelector('.filtros-modal__fundo'), fechar);
}

// Celular (gaveta que sobe de baixo): arrastar para baixo pelo topo, ou pelo conteúdo quando
// ele já está no início, fecha os filtros. Soltando antes do ponto, a gaveta volta ao lugar.
function iniciarArrastarParaFechar(painel, fundo, fechar) {
    const alca = painel.querySelector('.filtros-modal__alca');
    const corpo = painel.querySelector('.filtros-modal__corpo');
    if (!alca || !corpo) {
        return;
    }

    let inicioY = 0;
    let inicioTempo = 0;
    let deslocamento = 0;
    let podeArrastar = false;
    let arrastando = false;

    function eGaveta() {
        return getComputedStyle(alca).display !== 'none';
    }

    painel.addEventListener('touchstart', (e) => {
        podeArrastar = false;
        arrastando = false;
        if (!eGaveta() || e.touches.length !== 1) {
            return;
        }
        const noTopo = e.target.closest('.filtros-modal__topo, .filtros-modal__alca');
        const noCorpoNoInicio = e.target.closest('.filtros-modal__corpo') && corpo.scrollTop <= 0
            && !e.target.closest('.filtros-bairro__sugestoes');
        podeArrastar = Boolean(noTopo || noCorpoNoInicio);
        inicioY = e.touches[0].clientY;
        inicioTempo = Date.now();
        deslocamento = 0;
    }, { passive: true });

    painel.addEventListener('touchmove', (e) => {
        if (!podeArrastar) {
            return;
        }
        const dy = e.touches[0].clientY - inicioY;
        if (!arrastando) {
            if (dy < -4) {
                // Rolando o conteúdo para cima: não é gesto de fechar.
                podeArrastar = false;
                return;
            }
            if (dy < 8) {
                return;
            }
            arrastando = true;
            painel.style.transition = 'none';
            fundo.style.transition = 'none';
            if (document.activeElement && painel.contains(document.activeElement)) {
                document.activeElement.blur();
            }
        }
        e.preventDefault();
        deslocamento = Math.max(0, dy);
        painel.style.transform = `translateY(${deslocamento}px)`;
        fundo.style.opacity = String(Math.max(0, 1 - deslocamento / painel.offsetHeight));
    }, { passive: false });

    function soltar() {
        if (!arrastando) {
            podeArrastar = false;
            return;
        }
        const velocidade = deslocamento / Math.max(1, Date.now() - inicioTempo);
        const fecha = deslocamento > painel.offsetHeight * 0.25 || (deslocamento > 40 && velocidade > 0.5);
        painel.style.transition = '';
        fundo.style.transition = '';
        painel.style.transform = '';
        fundo.style.opacity = '';
        arrastando = false;
        podeArrastar = false;
        if (fecha) {
            fechar();
        }
    }
    painel.addEventListener('touchend', soltar);
    painel.addEventListener('touchcancel', soltar);
}

// Campo "Bairro" com sugestões ------------------------------------------------------

function iniciarBairros() {
    const bloco = document.querySelector('.js-filtro-bairro');
    if (!bloco) {
        return;
    }
    const bairros = JSON.parse(bloco.dataset.bairros || '[]');
    const campo = bloco.querySelector('.js-bairro-busca');
    const lista = bloco.querySelector('.js-bairro-sugestoes');
    const selecionados = bloco.querySelector('.js-bairros-selecionados');
    const iconeRemover = selecionados.dataset.icone;
    let ativo = -1;
    let resultados = [];

    function jaSelecionado(slug) {
        return !!selecionados.querySelector(`input[value="${CSS.escape(slug)}"]`);
    }

    function fecharLista() {
        lista.hidden = true;
        campo.setAttribute('aria-expanded', 'false');
        ativo = -1;
    }

    function renderizar() {
        const termo = normalizar(campo.value);
        if (termo.length < 2) {
            fecharLista();
            return;
        }
        resultados = bairros
            .filter((b) => !jaSelecionado(b.slug) && normalizar(b.nome).includes(termo))
            .slice(0, 8);
        lista.innerHTML = '';
        if (!resultados.length) {
            const vazio = document.createElement('li');
            vazio.textContent = 'Nenhum bairro encontrado';
            vazio.setAttribute('aria-disabled', 'true');
            lista.appendChild(vazio);
        }
        resultados.forEach((b, i) => {
            const item = document.createElement('li');
            item.setAttribute('role', 'option');
            item.dataset.indice = i;
            item.textContent = b.nome;
            const cidade = document.createElement('small');
            cidade.textContent = b.cidade;
            item.appendChild(cidade);
            lista.appendChild(item);
        });
        lista.hidden = false;
        campo.setAttribute('aria-expanded', 'true');
        ativo = -1;
    }

    function adicionar(bairro) {
        const chip = document.createElement('span');
        chip.className = 'chip-selecionado';
        chip.textContent = bairro.nome + ' ';
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'bairro[]';
        input.value = bairro.slug;
        const botao = document.createElement('button');
        botao.type = 'button';
        botao.className = 'js-bairro-remover';
        botao.setAttribute('aria-label', 'Remover ' + bairro.nome);
        botao.innerHTML = `<img src="${iconeRemover}" width="13" height="13" alt="">`;
        chip.append(input, botao);
        selecionados.appendChild(chip);
        campo.value = '';
        fecharLista();
        campo.focus();
    }

    function destacar(indice) {
        const itens = lista.querySelectorAll('li[role="option"]');
        itens.forEach((item) => item.classList.remove('is-ativo'));
        if (itens[indice]) {
            itens[indice].classList.add('is-ativo');
            itens[indice].scrollIntoView({ block: 'nearest' });
        }
        ativo = indice;
    }

    campo.addEventListener('input', renderizar);
    campo.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' && resultados.length) {
            e.preventDefault();
            destacar(Math.min(ativo + 1, resultados.length - 1));
        } else if (e.key === 'ArrowUp' && resultados.length) {
            e.preventDefault();
            destacar(Math.max(ativo - 1, 0));
        } else if (e.key === 'Enter') {
            // Enter no campo escolhe o bairro destacado em vez de enviar o formulário.
            if (!lista.hidden && resultados.length) {
                e.preventDefault();
                adicionar(resultados[Math.max(ativo, 0)]);
            }
        } else if (e.key === 'Escape' && !lista.hidden) {
            e.stopPropagation();
            fecharLista();
        }
    });
    campo.addEventListener('blur', () => window.setTimeout(fecharLista, 150));

    lista.addEventListener('mousedown', (e) => {
        const item = e.target.closest('li[role="option"]');
        if (item) {
            e.preventDefault();
            adicionar(resultados[Number(item.dataset.indice)]);
        }
    });

    selecionados.addEventListener('click', (e) => {
        const botao = e.target.closest('.js-bairro-remover');
        if (botao) {
            botao.closest('.chip-selecionado').remove();
            campo.focus();
        }
    });
}

// Formulários: números formatados e URL limpa -------------------------------------------

function iniciarFormularios() {
    document.querySelectorAll('.js-numero').forEach((campo) => {
        campo.addEventListener('input', () => {
            campo.value = formatarNumero(campo.value);
        });
    });

    document.querySelectorAll('.busca-header, .home-busca, .filtros-modal__painel, .imoveis-ordenar').forEach((form) => {
        form.addEventListener('submit', (e) => {
            if (e.defaultPrevented) {
                return;
            }
            e.preventDefault();
            form.querySelectorAll('.js-numero').forEach((campo) => {
                campo.value = campo.value.replace(/\D/g, '');
            });

            // Monta a URL sem campos vazios e com listas separadas por vírgula (bairro=a,b em vez de bairro[]=a&bairro[]=b).
            const listas = new Map();
            new FormData(form).forEach((valor, nome) => {
                if (valor === '') {
                    return;
                }
                const chave = nome.replace(/\[\]$/, '');
                listas.set(chave, (listas.get(chave) || []).concat(valor));
            });
            const url = new URL(form.action);
            url.search = [...listas]
                .map(([chave, valores]) => encodeURIComponent(chave) + '=' + valores.map(encodeURIComponent).join(','))
                .join('&');
            window.location.href = url.toString();
        });
    });

    document.querySelectorAll('.js-ordenar').forEach((select) => {
        select.addEventListener('change', () => select.form.requestSubmit());
    });
}

// Grade / lista -------------------------------------------------------------------------

function iniciarVisao() {
    document.querySelectorAll('.alternar-visao').forEach((grupo) => {
        const resultados = document.getElementById(grupo.dataset.alvo || 'imoveisResultados');
        const botoes = grupo.querySelectorAll('.js-visao');
        if (!resultados) {
            return;
        }
        // Na home a escolha não vai para a URL nem fica salva.
        const persistir = resultados.dataset.visaoUrl !== '0';

        function aplicar(visao, salvar) {
            resultados.classList.toggle('is-grade', visao === 'grade');
            resultados.classList.toggle('is-lista', visao === 'lista');
            botoes.forEach((botao) => {
                const ativo = botao.dataset.visao === visao;
                botao.classList.toggle('is-ativo', ativo);
                botao.setAttribute('aria-pressed', ativo ? 'true' : 'false');
            });

            if (!persistir) {
                return;
            }

            const url = new URL(window.location.href);
            if (visao === 'lista') {
                url.searchParams.set('visao', 'lista');
            } else {
                url.searchParams.delete('visao');
            }
            history.replaceState(null, '', url);

            const carregar = document.querySelector('.js-carregar-mais');
            if (carregar) {
                const urlMais = new URL(carregar.href);
                visao === 'lista' ? urlMais.searchParams.set('visao', 'lista') : urlMais.searchParams.delete('visao');
                carregar.href = urlMais.toString();
            }

            if (salvar) {
                gravarStorage(CHAVE_VISAO, visao);
            }
        }

        botoes.forEach((botao) => botao.addEventListener('click', () => {
            const visao = botao.dataset.visao;
            if (resultados.classList.contains(`is-${visao}`)) {
                return;
            }
            // Com animações ativas (motion.js), os cards se reorganizam em movimento (Flip).
            if (window.niMotion) {
                window.niMotion.trocarLayout(resultados, () => aplicar(visao, true));
            } else {
                aplicar(visao, true);
            }
        }));

        const params = new URLSearchParams(window.location.search);
        if (persistir && !params.has('visao') && lerStorage(CHAVE_VISAO, 'grade') === 'lista') {
            aplicar('lista', false);
        }
    });
}

// Galeria dos cards ---------------------------------------------------------------------

function mudarFoto(galeria, passo) {
    const fotos = JSON.parse(galeria.dataset.fotos || '[]');
    if (fotos.length < 2) {
        return;
    }
    const atual = Number(galeria.dataset.indice || 0);
    const proximo = (atual + passo + fotos.length) % fotos.length;
    const img = galeria.querySelector('.imovel-card__foto img');
    const link = galeria.querySelector('.imovel-card__foto');

    link.classList.add('is-carregando');
    const carregador = new Image();
    carregador.onload = carregador.onerror = () => {
        img.src = fotos[proximo];
        link.classList.remove('is-carregando');
    };
    carregador.src = fotos[proximo];

    galeria.dataset.indice = proximo;
    galeria.querySelectorAll('.imovel-card__dots span').forEach((dot, i) => dot.classList.toggle('is-ativo', i === proximo));

    // Pré-carrega a seguinte para a próxima troca ser imediata.
    new Image().src = fotos[(proximo + passo + fotos.length) % fotos.length];
}

function iniciarGalerias() {
    document.addEventListener('click', (e) => {
        const seta = e.target.closest('.js-galeria-anterior, .js-galeria-proxima');
        if (seta) {
            e.preventDefault();
            mudarFoto(seta.closest('.js-galeria'), seta.classList.contains('js-galeria-anterior') ? -1 : 1);
        }
    });

    let inicioX = null;
    document.addEventListener('touchstart', (e) => {
        if (e.target.closest('.js-galeria')) {
            inicioX = e.touches[0].clientX;
        }
    }, { passive: true });
    document.addEventListener('touchend', (e) => {
        const galeria = e.target.closest('.js-galeria');
        if (galeria && inicioX !== null) {
            const distancia = e.changedTouches[0].clientX - inicioX;
            if (Math.abs(distancia) > 40) {
                mudarFoto(galeria, distancia < 0 ? 1 : -1);
            }
        }
        inicioX = null;
    }, { passive: true });
}

// Rolagem infinita -----------------------------------------------------------------------
// A próxima página carrega sozinha um pouco antes de a pessoa chegar ao fim da lista.
// O link "Carregar mais" só aparece se o carregamento falhar (ou sem JS).

function iniciarCarregarMais() {
    const area = document.querySelector('.js-carregar-mais-area');
    const botao = document.querySelector('.js-carregar-mais');
    const aviso = document.querySelector('.js-carregar-mais-aviso');
    const resultados = document.getElementById('imoveisResultados');
    if (!area || !botao || !resultados || !window.nucleoImob) {
        return;
    }

    let carregando = false;
    let observador = null;

    function carregar() {
        if (carregando) {
            return;
        }
        carregando = true;
        area.classList.add('is-carregando');

        const proxima = Number(resultados.dataset.pagina || 1) + 1;
        const params = new URLSearchParams(window.location.search);
        params.set('action', 'ni-carregar-imoveis');
        params.set('pagina', proxima);

        fetch(`${window.nucleoImob.ajaxurl}?${params.toString()}`, { credentials: 'same-origin' })
            .then((resposta) => resposta.json())
            .then((json) => {
                if (!json.success) {
                    throw new Error('Resposta inválida');
                }
                const temporario = document.createElement('div');
                temporario.innerHTML = json.data.html;
                const elementos = [...temporario.children];
                const novos = elementos.length;
                resultados.append(...elementos);
                // Animação de entrada dos novos cards (motion.js).
                document.dispatchEvent(new CustomEvent('ni:novos-imoveis', { detail: elementos }));
                resultados.dataset.pagina = proxima;
                if (aviso) {
                    aviso.textContent = `Mais ${novos} imóveis carregados.`;
                }

                if (!json.data.tem_mais) {
                    if (observador) {
                        observador.disconnect();
                    }
                    area.remove();
                    return;
                }
                const url = new URL(botao.href);
                url.searchParams.set('pagina', proxima + 1);
                botao.href = url.toString();
                carregando = false;
                area.classList.remove('is-carregando');
                // Se o fim da lista continua visível (tela alta), o observador precisa reavaliar.
                if (observador) {
                    observador.unobserve(area);
                    observador.observe(area);
                }
            })
            .catch(() => {
                // Falhou: para o automático e mostra o link (que também funciona sem AJAX).
                if (observador) {
                    observador.disconnect();
                }
                area.classList.remove('is-carregando', 'is-automatico');
                carregando = false;
            });
    }

    botao.addEventListener('click', (e) => {
        if (area.classList.contains('is-automatico')) {
            e.preventDefault();
            carregar();
        }
    });

    if (!('IntersectionObserver' in window)) {
        // Navegador antigo: fica o botão.
        return;
    }
    area.classList.add('is-automatico');
    observador = new IntersectionObserver((entradas) => {
        if (entradas.some((entrada) => entrada.isIntersecting)) {
            carregar();
        }
    }, { rootMargin: '0px 0px 600px 0px' });
    observador.observe(area);
}

export default {
    init() {
        iniciarModal();
        iniciarBairros();
        iniciarFormularios();
        iniciarVisao();
        iniciarGalerias();
        iniciarCarregarMais();
    },
};
